import { useEffect, useState } from 'react';
import { getPendingLoans, decideLoan } from '../../TWGLogin/axiosConfig';
import NewLoan from '../pages/NewLoan';
import Toast from '../../../Toast';
import LoanPreviewModal from './LoanPreviewModal'
import { generateLoanSanctionPDF } from '../utils/loanSanctionPdfGenerator';


const NewLoanContainer = () => {
  const [loans, setLoans] = useState([]);
  const [processingIds, setProcessingIds] = useState([]);
  const [selectedLoan, setSelectedLoan] = useState(null);

  useEffect(() => {
    getPendingLoans().then(res => setLoans(res.data.data || []));
  }, []);

  // ✅ ADD HERE (top of component file, before handleDecision)
const prepareLoanForPDF = (loan) => ({
  ...loan,
  totalGoldValue: loan.totalGoldValue || 0,
  totalDeductions: loan.totalDeductions || (
    (loan.processingFee || 0) +
    (loan.insuranceCharges || 0) +
    (loan.appraiserFee || 0)
  ),
  netDisbursement: loan.netDisbursement || loan.disbursedAmount,
  dueDate: loan.dueDate || loan.nextDueDate
});
  const handleDecision = async (loan, decision) => {
    setProcessingIds(prev => [...prev, loan._id]);
  
    try {
      const res = await decideLoan(loan._id, { decision });
  
      let updatedLoan = res.data.data;
  
      // ✅ SAFETY FALLBACKS (VERY IMPORTANT)
      updatedLoan.totalGoldValue =
        updatedLoan.totalGoldValue ||
        updatedLoan.goldItems?.reduce(
          (sum, item) => sum + (item.estimatedValue || 0),
          0
        );
  
      updatedLoan.totalDeductions =
        updatedLoan.processingFee +
        updatedLoan.insuranceCharges +
        updatedLoan.appraiserFee;
  
      updatedLoan.netDisbursement =
        updatedLoan.disbursedAmount;
  
      if (decision === 'approve') {
        generateLoanSanctionPDF(
          prepareLoanForPDF(updatedLoan),
          updatedLoan.approvedBy
        );
      }
  
      setLoans(prev => prev.filter(l => l._id !== loan._id));
      setSelectedLoan(null);
  
      Toast('success', `Loan ${decision}d successfully`);
    } catch (e) {
      Toast('error', 'Action failed');
    } finally {
      setProcessingIds(prev => prev.filter(id => id !== loan._id));
    }
  };

  return (
    <>
      <NewLoan
        loans={loans}
        processingIds={processingIds}
        onView={setSelectedLoan}
      />

      {selectedLoan && (
        <LoanPreviewModal
          loan={selectedLoan}
          processing={processingIds.includes(selectedLoan._id)}
          onApprove={() => handleDecision(selectedLoan, 'approve')}
          onReject={() => handleDecision(selectedLoan, 'reject')}
          onClose={() => setSelectedLoan(null)}
        />
      )}
    </>
  );
};


export default NewLoanContainer;
